import { WizardContainer } from '@/features/contracts/components/wizard/WizardContainer';

interface ContractCreatePageProps {
  societyId?: string;
  onCreated?: (contractId: number) => void;
  onCancel?: () => void;
  showDrafts?: boolean;
  /** Mode embarqué dans un onglet (stepper/footer sticky au lieu de fixed) */
  embedded?: boolean;
}

/**
 * Page de création d'un contrat
 */
export function ContractCreatePage({ societyId, onCreated, onCancel, showDrafts = true, embedded }: ContractCreatePageProps = {}) {
  return (
    <WizardContainer societyId={societyId} onCreated={onCreated} onCancel={onCancel} showDrafts={showDrafts} embedded={embedded} />
  );
}
